import { useQuery } from "@tanstack/react-query";

import { integrationsApi } from "../api/integrations.api";

export function useGetApiKeys(
  integrationName: string,
  tenantId: string | null | undefined,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: ["integrationApiKey", integrationName, tenantId],
    queryFn: () => integrationsApi.getIntegrationApiKeys(integrationName, tenantId!),
    enabled: enabled && !!tenantId,
    staleTime: 0, // Always refetch when dialog opens
    refetchOnMount: true,
  });
}
